import { render, staticRenderFns } from "./TabButton.vue?vue&type=template&id=a21e387e"
import script from "./TabButton.vue?vue&type=script&lang=ts"
export * from "./TabButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports